import React from 'react';
import { useNavigate } from 'react-router-dom';

import BasicButton from '../Common/Button/BasicButton';
import ProductFlicking from '../Common/ProductFlicking';
import { colors } from '@/const/colors';
import { SALES_TYPE_ASSURANCE } from '@/const/products';

const AssuranceProduts = ({ products }: AssuranceProductsProps) => {
  const navigate = useNavigate();

  const onClickMore = () => {
    navigate('/products', { state: { salesType: SALES_TYPE_ASSURANCE } });
  };

  return (
    <>
      <div className="flex flex-col pb-6 w-full bg-gray-0">
        <div className="p-6">
          <h2 className="text-[20px] font-semibold text-gray-8">직트럭에서 검수한 차량</h2>
        </div>
        <ProductFlicking products={products.data ?? []}></ProductFlicking>
        <div className="px-4 pt-0">
          <BasicButton
            name={`총 ${products.totalElements}건 더보기`}
            bgColor={colors.gray[0]}
            borderColor={colors.gradient['blueGradient-blue-to-blue']}
            textColor={colors.gradient['blueGradient-blue-to-blue']}
            fontSize={16}
            height={48}
            fontWeight="bold"
            onClick={() => onClickMore()}
          />
        </div>
      </div>
    </>
  );
};

export default AssuranceProduts;
